<template>
  <div class="Toptitle">
    <h3><i class="fa fa-tags"></i>{{title}}</h3>
    <img src="../../assets/static/images/footer-split.png" alt="">
  </div>
</template>

<script>
  export default{
      props:["title"]
  }
</script>

<style>
.Toptitle{margin-top: 20px;}
 .Toptitle h3{font-size: 18px;color: #000000;font-family: '微软雅黑';margin:5px 0;}
 .Toptitle h3 i{margin-right:5px;}
 .Toptitle img{display: block;width: 100%;}
</style>
